import { Stack, Typography } from '@mui/material'
import { InfoBubble } from '~/@ui/info-bubble/InfoBubble'

type Props = {
  label: string
  value: number
  svg: React.FC<React.SVGProps<SVGSVGElement>>
  hintText?: string
}

export const TableRow = ({ label, value, svg, hintText = '' }: Props) => {
  const integerPart = Math.floor(value)
  const formattedNumber = value.toFixed(2)
  const decimalPart = formattedNumber.split('.')[1]

  const SvgIcon = svg

  return (
    <Stack className="flex-row h-[77px] justify-between items-center  gap-4">
      <Stack className="w-11 h-11 justify-center items-center bg-zGrey200 rounded-full">
        <SvgIcon />
      </Stack>

      <Stack className="flex-1">
        <Typography className="text-3d font-medium text-zBlack200">
          {label}
        </Typography>
        <Stack className="flex-row items-end">
          <Typography className="text-lg/[18px] font-bolt text-zBlack200 tabular-nums">
            {integerPart.toLocaleString('sk-SK')},
          </Typography>
          <Typography className="text-xs/[13px] font-bolt text-zBlack200 ml-0.5 tabular-nums">
            {decimalPart}
          </Typography>
          <Typography className="text-lg/[18px] font-bolt text-zBlack200 ml-1 tabular-nums">
            €
          </Typography>
        </Stack>
      </Stack>

      <InfoBubble text={hintText} />
    </Stack>
  )
}
